import usePageTracking from "./usePageTracking";

const PageTracker = () => {
  usePageTracking();
  return null;
};

export default PageTracker;